import GeoJSONReader from 'jsts/org/locationtech/jts/io/GeoJSONReader';
import IsValidOp from 'jsts/org/locationtech/jts/operation/valid/IsValidOp';
import IsSimpleOp from 'jsts/org/locationtech/jts/operation/IsSimpleOp';

const jstsGetGeometry = (feature) => {
    const reader = new GeoJSONReader();
    if (feature &&
    feature.geometry &&
    feature.geometry.coordinates &&
    feature.geometry.coordinates.length > 0
    ) {
        return reader.read(feature.geometry);
    } else {
        throw new Error('jsts: cannot read GeoJson');
    }
};

export const feature = {
    isValid (feature) {
        const geom = jstsGetGeometry(feature);
        if (geom) {
            return new IsValidOp(geom).isValid();
        } else {
            throw new Error('isValid: feature contains invalid geometry type');
        }
    },
    isSimple (feature) {
        const geom = jstsGetGeometry(feature);
        if (geom) {
            const isValid = new IsValidOp(geom).isValid();
            const isSimple = new IsSimpleOp(geom).isSimple();

            return isValid && isSimple;
        } else {
            throw new Error('isSimple: feature does not comply with OGC Simple requirements');
        }
    }
};

export default { feature };
